/**
 * @ngdoc filter
 * @name cfn.convertPerAreaUnit
 * @description
 * # convertPerAreaUnit
 * Converts a per area unit from DB units to user defined one (e.g. kg/ha to kg/m2 or g/m2)
 */
angular.module('cfn').filter('convertPerAreaUnit', [
  'unitConverter',
  'userSettingsService',
  function(unitConverter, userSettingsService) {
    /**
     * If no unit is provided the conversion will retain the main unit (i.e. kg/ha -> kg/m2).
     * Otherwise the main unit might also be change by selecting the unit that more closely match the original ratio
     * I.e: kg/ha -> g/m2 because 1/ha = 1/10.000 * 1/m2 ~ 1.000 g = 1 kg
     * @param {number} value value to be converted (if it's not a number it will be returned as is)
     * @param {string} main unit enum (e.g. MASS_KG in case of MASSPERAREA_KGPERHA)
     */
    return function(value, unit) {
      if (_.isNumber(value)) {
        var areaFactor = unitConverter.convert(
          'AREAL_HA',
          userSettingsService.getAreaUnitEnum(),
          1
        );
        if (unit) {
          var betterMatchingUnit = unitConverter.unitForPerAreaUnitConversion(
            unit,
            'AREAL_HA',
            userSettingsService.getAreaUnitEnum(),
            userSettingsService.getIsoCountryEnum()
          );
          if (betterMatchingUnit !== unit)
            console.log('Using ' + betterMatchingUnit + ' instead of ' + unit);
          value = unitConverter.convert(unit, betterMatchingUnit, value);
        }
        return value / areaFactor;
      }

      return value;
    };
  }
]);

angular.module('cfn').filter('computePerAreaUnit', [
  'unitConverter',
  'userSettingsService',
  function(unitConverter, userSettingsService) {
    'use strict';

    /**
     * Returns the resulting unit that will be used if convertPerAreaUnit is used.
     * @param {string} main unit enum (e.g. MASS_KG in case of MASSPERAREA_KGPERHA)
     */
    return function(unit) {
      if (unit) {
        return unitConverter.unitForPerAreaUnitConversion(
          unit,
          'AREAL_HA',
          userSettingsService.getAreaUnitEnum(),
          userSettingsService.getIsoCountryEnum()
        );
      }
    };
  }
]);
